export const RESET = 'EXCMSLA_LIST_RESET'
export const SET_ITEMS = 'EXCMSLA_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMSLA_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMSLA_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMSLA_LIST_TOGGLE_LOADING'
